import React from 'react'
import injectStyles from 'react-jss'
import styles from './styles'

const LoadMore = ({ action, isLoading, visible, classes }) => {
  if (!visible) return null
  return (
    <div className={classes.wrapper}>
      {isLoading ? (
        <div className={classes.loadingLabel}>Loading...</div>
      ) : (
        <div onClick={action} className={classes.button}>
          Load more
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(LoadMore)
